import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import CONFIG from '../../../../config/app';
import {
  Container,
  FormContainer,
  ButtonsContainer,
} from '../../../../components/Layout';
import ItfApiForm from '../../../../components/Common/TrackedItfApiForm';
import {
  Spinner,
  Button,
  Header,
  InputSelect,
  FieldsMapper,
  PriceHistory,
} from '../../../../components/Common';
import ApiService from '../../../../services/api-service';
import { ProductForm } from 'profilpol-types';
import { ButtonType } from '../../../../components/Common/Button';
import { successNotification } from '../../../../actions/notifications';
import { formOnTranslateString } from '../../../../utils/trans-form';
import { useParams } from 'react-router';
import { history } from '../../../../App';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { pathToObject } from '../../../../utils/path-to-object';

const Edit = () => {
  const { productId } = useParams<{ productId: string }>();
  const dispatch = useDispatch();
  const formRef = useRef<any>(null);
  // Track current field values for cross-field calculation
  const fieldValues = useRef<{ pricePerKg: number | null; weight: number | null }>({
    pricePerKg: null,
    weight: null,
  });

  const recalcPrice = (pricePerKg: number | null, weight: number | null) => {
    if (formRef.current?.api && pricePerKg && weight) {
      const newPrice = Number((pricePerKg * weight).toFixed(4));
      // Delay setValue to next tick so React processes the first setState first
      setTimeout(() => {
        formRef.current?.api?.setValue('price', newPrice);
      }, 0);
    }
  };

  return (
    <Container>
      <Header header="profiles.edit" />
      <Button
        leftIcon
        link
        faIcon={faChevronLeft}
        text={'application.back'}
        to="/panel/profiles"
      />
      <div className="edit-with-history">
        <FormContainer>
          <ItfApiForm
            ref={formRef}
            formId="profileForm"
            schemaMayBeDynamic={true}
            schemaCacheEnabled={false}
            loadingInfoAboveContent
            loadingInfo={<Spinner overlay halfTransparent />}
            sendDelay={200}
            requiredIndicator="*"
            schemaFetcher={() =>
              ApiService.loadForm(`product/form/update-profile/${productId}`)
            }
            sendFetcher={(formId: string, values: ProductForm) => {
              const updatedProduct = {
                ...values,
              };

              const parsed = pathToObject(updatedProduct);

              const product = new FormData();
              for (const key in parsed) {
                if (key === 'image' && values.image) {
                  product.append('image', parsed.image, parsed.image.name);
                } else product.append(key, JSON.stringify(parsed[key]));
              }

              return ApiService.sendForm(
                `product/profile/${productId}`,
                product,
                'PATCH',
                null
              );
            }}
            submitButton={(loading: boolean) => (
              <ButtonsContainer>
                <Button
                  disabled={loading}
                  big
                  type={ButtonType.Submit}
                  primary
                  text={'application.save'}
                />
              </ButtonsContainer>
            )}
            onRenderFullField={(
              field,
              errors,
              fieldHtmlId,
              currentValue,
              onChange,
              onFocus,
              onBlur
            ) => {
              // Track weight and pricePerKg values as they render
              if (field.id === 'weight') {
                fieldValues.current.weight = currentValue ? Number(currentValue) : null;
              }
              if (field.id === 'pricePerKg') {
                fieldValues.current.pricePerKg = currentValue ? Number(currentValue) : null;
              }

              if (field.id === 'pricePerKg') {
                const wrappedOnChange = (value: any) => {
                  onChange(value);
                  const numVal = value ? Number(value) : null;
                  fieldValues.current.pricePerKg = numVal;
                  recalcPrice(numVal, fieldValues.current.weight);
                };
                return FieldsMapper(field, errors, fieldHtmlId, currentValue, wrappedOnChange, onFocus, onBlur);
              }

              if (field.id === 'weight') {
                const wrappedOnChange = (value: any) => {
                  onChange(value);
                  const numVal = value ? Number(value) : null;
                  fieldValues.current.weight = numVal;
                  recalcPrice(fieldValues.current.pricePerKg, numVal);
                };
                return FieldsMapper(field, errors, fieldHtmlId, currentValue, wrappedOnChange, onFocus, onBlur);
              }

              return FieldsMapper(field, errors, fieldHtmlId, currentValue, onChange, onFocus, onBlur);
            }}
            onSavedSuccessfully={() => {
              dispatch(successNotification('profile.updated'));
              history.push('/panel/profiles');
            }}
            onTranslateString={formOnTranslateString}
            thirdPartyComponents={{
              ReactSelect: InputSelect,
              ReactCreatableSelect: InputSelect,
            }}
          />
        </FormContainer>
        <PriceHistory productId={productId} showPricePerKg />
      </div>
    </Container>
  );
};

export default Edit;
